import axios from 'axios';
import { getCookie } from '../_helpers/cookie';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const buildHeaders = (token) => ({
  Authorization: `Bearer ${token || ''}`,
  'x-api-key': X_API_KEY,
});

export const taxRatesService = {
  list,
  create,
  update,
  remove,
};

function list(token) {
  const authToken = token || getCookie('token');
  return axios
    .get(`${API_URL}tax-rates/`, {
      headers: buildHeaders(authToken),
    })
    .then((response) => response.data);
}

function create(payload, token) {
  const authToken = token || getCookie('token');
  return axios
    .post(`${API_URL}tax-rates/`, payload, {
      headers: {
        ...buildHeaders(authToken),
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
}

function update(id, payload, token) {
  const authToken = token || getCookie('token');
  return axios
    .put(`${API_URL}tax-rates/${id}/`, payload, {
      headers: {
        ...buildHeaders(authToken),
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
}

function remove(id, token) {
  const authToken = token || getCookie('token');
  return axios
    .delete(`${API_URL}tax-rates/${id}/`, {
      headers: buildHeaders(authToken),
    })
    .then((response) => response.data);
}

